import {create} from 'zustand';

type ReportState = {
  hasInlineComments: boolean;
  setHasInlineComments: (hasComments: boolean) => void;
  isSyncingToRedux: boolean;
  setIsSyncingToRedux: (isSyncing: boolean) => void;
};

export const useReportState = create<ReportState>()(set => ({
  hasInlineComments: false,
  setHasInlineComments: (hasComments: boolean) =>
    set(() => ({hasInlineComments: hasComments})),
  isSyncingToRedux: false,
  setIsSyncingToRedux: (isSyncing: boolean) => {
    set(() => ({isSyncingToRedux: isSyncing}));
  },
}));
